import { IconViewOutline } from '@featuring-corp/icons';
import { disabledAnchor } from '@styles/vanilla-extract/utils';
import React from 'react';

import round from '@utils/round';

import { Link } from 'react-router-dom';

import CoreImg from '@shared/CoreImg';

import {
	containerClass,
	imgContainerClass,
	imgContentClass,
	paidAdTagClass,
	textClass,
	textContainerClass,
	textContentClass,
	videoLengthTagClass,
} from './style.css';
import CustomLink from 'src/shared/custom-link/CustomLink';

export interface VideoContentItemProps {
	outLink?: string;
	imgSrc?: string;
	viewCount?: number;
	contentText?: string;
	idx?: number;
	isPaidAd?: boolean;
	videoLength?: string;

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const VideoContentItem = ({
	idx = 0,
	isPaidAd,
	isLoading,
	isError,
	lackOfPermission,
	...props
}: VideoContentItemProps) => {
	const available = !isLoading && !isError && !lackOfPermission;
	const outLink = !available ? '' : props.outLink;
	const imgSrc = isError
		? 'public/images/report/no-image.png'
		: lackOfPermission
		? `https://source.unsplash.com/random?${idx}`
		: props.imgSrc;

	const viewCount =
		isLoading || isError
			? '-'
			: lackOfPermission
			? '00'
			: props.viewCount
			? round(props.viewCount, 'down')
			: '-';
	const contentText =
		isLoading || isError
			? '-'
			: lackOfPermission
			? '예시 텍스트입니다.'
			: props.contentText ?? '-';
	const videoLength =
		isLoading || isError ? '-' : lackOfPermission ? '00:00:00' : props.videoLength ?? '-';

	return (
		<CustomLink
			href={outLink ?? ''}
			target={'_blank'}
			className={disabledAnchor}
			aria-disabled={!available}
		>
			<div className={containerClass}>
				<div className={imgContainerClass}>
					<div className={imgContentClass}>
						<CoreImg
							src={imgSrc ?? ''}
							alt="feed-content-image"
							is_loading={isLoading}
							object_fit="contain"
						/>
					</div>
					{isPaidAd && <div className={paidAdTagClass}>유료 광고 포함</div>}
					<div className={videoLengthTagClass}>{videoLength}</div>
				</div>

				<div className={textContainerClass}>
					<div className={textContentClass}>{contentText}</div>
					<div className={textClass}>
						<IconViewOutline />
						{viewCount} 회
					</div>
				</div>
			</div>
		</CustomLink>
	);
};

export default VideoContentItem;
